import type { ReactNode } from 'react';

export const symbol_resize_window: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M819-141q-9 9-21 9t-21-9L141-777q-9-9-8.5-20.5T142-818q9-9 21-9t21 9l635 635q9 9 9 21t-9 21Zm-419 0q-9 9-21 8.5t-21-9.5L141-359q-9-9-8.5-20.5T142-400q9-9 21-9t21 9l216 216q9 9 9 21.5t-9 21.5Z"
		/>
	</svg>
);
